import { Switch } from '@thanx/uikit/switch'
import { TextArea } from '@thanx/uikit/textarea'
import { buildTranslate } from 'locales'
import { Button } from 'react-bootstrap'
import ModifierPopover, {
  ModifierPopoverVariant,
} from 'scenes/RedeemManager/Builder/ConfigurationStep/OnlineRedemptionCard/ModifierPopover'

interface ModifierIdDisplayProps {
  label: string
  name: string
  helpText?: string
  secondaryHelpText?: string
  className?: string
  selectedIds: string[]
  disabled?: boolean
  setValue: (ids: string[]) => void
  toggleVisibility?: () => void
  hideLabel?: string
  shouldDisplayPopover?: boolean
  popoverVariant?: ModifierPopoverVariant
}

function parseCommaSeparatedIds(stringValue: string): string[] {
  return stringValue
    .split(',')
    .map(id => id.trim())
    .filter(id => id.length > 0)
}

const t = buildTranslate('redeem_manager.modifier_select')

const ModifierIdInput = ({
  label,
  name,
  helpText,
  secondaryHelpText,
  className = '',
  selectedIds,
  disabled = false,
  toggleVisibility,
  hideLabel,
  setValue,
  shouldDisplayPopover = false,
  popoverVariant,
}: ModifierIdDisplayProps) => (
  <div className="mt-m">
    <div className="d-flex flex-row justify-content-between">
      <div className="d-flex flex-row">
        <label id={name} className="body-text-4 bold mb-0">
          {label}
        </label>
        <Switch condition={shouldDisplayPopover}>
          <ModifierPopover variant={popoverVariant} />
        </Switch>
      </div>
      <Switch condition={Boolean(toggleVisibility)}>
        <Button
          bsStyle="link"
          type="button"
          onClick={toggleVisibility}
          className="p-0 m-0"
        >
          {hideLabel ?? t('wrapper.hide')}
        </Button>
      </Switch>
    </div>
    <Switch condition={Boolean(helpText)}>
      <p className="body-text-4 mt-xs grey-70">{helpText}</p>
    </Switch>
    <Switch condition={Boolean(secondaryHelpText)}>
      <p className="body-text-4 mt-xs grey-70">{secondaryHelpText}</p>
    </Switch>
    <TextArea
      className={className}
      id={name}
      name={name}
      value={selectedIds.join(',')}
      onChange={stringValue => setValue(parseCommaSeparatedIds(stringValue))}
      disabled={disabled}
      placeholder={disabled ? t('product_id_required') : ''}
    />
  </div>
)

export default ModifierIdInput
